// #region Global Imports
import * as React from 'react';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import type { IProps } from '@components/Paragraphs/ParagraphText/ParagraphText';
import { getFragmentData } from '@generated/fragment-masking';
import styles from './ParagraphText.module.sass';
// #endregion Local Imports
export const ParagraphTextFragment = gql(/* GraphQL */ `
  fragment ParagraphTextFragment on ParagraphText {
    fieldText {
      processed
    }
  }
`);

export const ParagraphText: React.FunctionComponent<IProps.ParagraphText> = ({
  paragraph: _paragraph,
}) => {
  const paragraph = getFragmentData(ParagraphTextFragment, _paragraph);
  return (
    <div className={styles.ParagraphText__root}>
      <div
        dangerouslySetInnerHTML={{
          __html: String(paragraph.fieldText?.processed),
        }}
      />
    </div>
  );
};
